import axios from 'axios'
import { cookiesToObject } from '../utils'

export const API_SUPPORTED_FEATURES = [
  'GENERAL_VIDEO_ENDING_EXERCISE',
  'LEARNING_JOURNEY_POWER_UPS',
  'TUTOR_VIDEO_MESSAGE_IN_LEARNING_JOURNEY',
  'LESSONS_IN_LIBRARY',
  'FEATURE_CONFIG_V2',
  'UNAVAILABLE_ATTRIBUTE_ON_LESSONS_IN_LIBRARY',
  'NEW_THIN_ACTIVITY_COVERS',
  'PICTURELESS_READING_ACTIVITIES',
  'NO_JOURNEY_TAB',
  'ROUTINE_ACCESS_TOKEN_POWER_UP_TUTOR_VIDEO_MESSAGE',
  'LIBRARY_PAGINATION',
  'CEFR_SHELVES_IN_LIBRARY'
]

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'X-astrid-features': btoa(
      JSON.stringify({
        supportedFeatures: API_SUPPORTED_FEATURES
      })
    )
  }
})

// If token exists add it to request headers
axiosInstance.interceptors.request.use((config) => {
  const cookiesObj = cookiesToObject()
  if (cookiesObj.token) {
    config.headers = { ...config.headers, Authorization: `${cookiesObj.token}` }
  }
  return config
})

export default axiosInstance
